import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    status_label: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        fontSize: '13px',
        fontWeight: 600,
    },
    icon: {
        fontSize: '16px',
    },
    active: {
        color: theme.palette.success.main,
    },
    inactive: {
        color: theme.palette.error.main,
    },
    internal: {
        color: theme.palette.grey[600],
    },
    removed: {
        color: theme.palette.grey[400],
    },
}));

export {useStyles}
